import { ViewModel, View, ObservableArray } from "binder"
import { UsageAmountManipulationView } from "./usageAmountManipulation-view"
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { IUsageAmount } from "./IUsageAmount";
import { UsageAmountEditorViewModel, UsageAmountInserter, UsageAmountUpdater } from "./usageAmountEditor/usageAmountEditor-viewModel";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";

export class UsageAmountManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف میزان مصرف ابزار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.usageAmounts = ObservableArray.create<UsageAmount>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new UsageAmountManipulationView();
    }
    public getTypeId(): string {
        return "VM-476C33CC-7344-48A1-8BA0-B5381B4EECF5"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set usageAmounts(v: ObservableArray<UsageAmount>) { this._usageAmounts = v; } public get usageAmounts(): ObservableArray<UsageAmount> { return this._usageAmounts; } private _usageAmounts: ObservableArray<UsageAmount>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/UsageAmountServices/ListAllUsageAmounts', {
                FilteringInformation: filteringInformation
            });
            this.usageAmounts.update(...result.UsageAmounts.map((x, i) => {
                let u = new UsageAmount(this);
                u.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                u.id = x.UsageAmountId;
                u.amount = x.Amount;
                u.toolModelId = x.ToolModelId;
                u.toolModelName = x.ToolModelName;
                u.toolModelFromProducerId = x.ToolModelFromProducerId;
                u.toolModelFromProducerName = x.ToolProducerName;
                u.toolStatusId = x.ToolValidStatusId;
                u.toolStatusName = x.ToolValidStatusName;
                u.toolPlaceId = x.ToolPlaceId;
                u.toolPlaceName = x.ToolPlaceName;
                u.activityId = x.ActivityId;
                u.activityName = x.ActivityName;
                u.opcId = x.OpcId;
                return u;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new UsageAmountEditorViewModel(this, new UsageAmountInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(usageAmount: IUsageAmount) {
        let popup = new UsageAmountEditorViewModel(this, new UsageAmountUpdater());
        await usageAmount.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(usageAmount: UsageAmount): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/UsageAmountServices/DeleteUsageAmount", {
                    UsageAmountId: usageAmount.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class UsageAmount extends ViewModel implements IUsageAmount {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: UsageAmountManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: UsageAmountManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set toolModelId(v: string) { this._toolModelId = v; } public get toolModelId(): string { return this._toolModelId; } private _toolModelId: string;
    public set toolModelName(v: string) { this._toolModelName = v; } public get toolModelName(): string { return this._toolModelName; } private _toolModelName: string;
    public set toolModelFromProducerId(v: string) { this._toolModelFromProducerId = v; } public get toolModelFromProducerId(): string { return this._toolModelFromProducerId; } private _toolModelFromProducerId: string;
    public set toolModelFromProducerName(v: string) { this._toolModelFromProducerName = v; } public get toolModelFromProducerName(): string { return this._toolModelFromProducerName; } private _toolModelFromProducerName: string;
    public set opcId(v: string) { this._opcId = v; } public get opcId(): string { return this._opcId; } private _opcId: string;
    public set opcName(v: string) { this._opcName = v; } public get opcName(): string { return this._opcName; } private _opcName: string;
    public set activityId(v: string) { this._activityId = v; } public get activityId(): string { return this._activityId; } private _activityId: string;
    public set activityName(v: string) { this._activityName = v; } public get activityName(): string { return this._activityName; } private _activityName: string;
    public set toolPlaceId(v: string) { this._toolPlaceId = v; } public get toolPlaceId(): string { return this._toolPlaceId; } private _toolPlaceId: string;
    public set toolPlaceName(v: string) { this._toolPlaceName = v; } public get toolPlaceName(): string { return this._toolPlaceName; } private _toolPlaceName: string;
    public set toolStatusId(v: string) { this._toolStatusId = v; } public get toolStatusId(): string { return this._toolStatusId; } private _toolStatusId: string;
    public set toolStatusName(v: string) { this._toolStatusName = v; } public get toolStatusName(): string { return this._toolStatusName; } private _toolStatusName: string;

    setToolModelId(id: string) {
        this.toolModelId = id;
    }
    getToolModelId(): string {
        return this.toolModelId;
    }

    setToolModelFromProducerId(id: string) {
        this.toolModelFromProducerId = id;
    }
    getToolModelFromProducerId(): string {
        return this.toolModelFromProducerId;
    }

    setOPCId(id: string) {
        this.opcId = id;
    }
    getOPCId(): string {
        return this.opcId;
    }

    setActivityId(id: string) {
        this.activityId = id;
    }
    getActivityId(): string {
        return this.activityId;
    }

    setToolPlaceId(id: string) {
        this.toolPlaceId = id;
    }
    getToolPlaceId(): string {
        return this.toolPlaceId;
    }

    setToolStatusId(id: string) {
        this.toolStatusId = id;
    }
    getToolStatusId(): string {
        return this.toolStatusId;
    }

    async cloneTo(usageAmount: IUsageAmount) {
        usageAmount.id = this.id;
        usageAmount.amount = this.amount;
        usageAmount.setToolModelId(this.toolModelId);
        usageAmount.setToolModelFromProducerId(this.toolModelFromProducerId);
        usageAmount.setToolStatusId(this.toolStatusId);
        usageAmount.setOPCId(this.opcId);
        usageAmount.setActivityId(this.activityId);
        usageAmount.setToolPlaceId(this.toolPlaceId);
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
